import { AreaI } from "interfaces/Area";
import { ReactNode, useState } from "react";
import { Table } from "react-bootstrap";
import { AreaRow } from "./AreaRow";

interface Props {
  elementos: AreaI[];
  renderActions?: (elemento: AreaI) => ReactNode;
}

export const AreaTable = ({ elementos = [], renderActions }: Props) => {
  const [selectedNotificacionId, setSelectedNotificacionId] = useState<
    null | number | string
  >(null);

  const [showDetailModal, setShowDetailModal] = useState(false);

  const handleShowDetailModal = (id: number | string) => {
    setSelectedNotificacionId(id);
    setShowDetailModal(true);
  };

  const handleCloseModal = () => {
    setShowDetailModal(false);
  };

  return (
    <>
      <Table striped bordered className="table-container">
        <thead>
          <tr className="table-heading">
            <th>ID</th>
            <th>Nombre</th>
            <th>Descripcion</th>
            <th>Nivel</th>
            {renderActions && (
              <th className="text-center" style={{ maxWidth: "50px" }}>
                Acciones
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {elementos.length > 0 ? (
            elementos.map((ctEl) => (
              <AreaRow
                key={ctEl.id}
                elemento={ctEl}
                renderActions={renderActions}
              />
            ))
          ) : (
            <tr>
              <td
                colSpan={renderActions ? 6 : 5}
                className="text-center table-error-message"
              >
                <p>
                  <b>No hay Títulos para visualizar.</b> Para poder visualizar
                  títulos debes <br /> seleccionar el botón agregar «Nueva
                  Área».
                </p>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
};
